import _ from "lodash";

jQuery(document).ready(function($) {
    $('a').filter(function() {
        return this.hostname && this.hostname !== location.hostname;
    }).attr("target","_blank").attr('type', 'external');

    $('.view-in-de-buurt .bef-link').each(function(){
        let href = $(this).attr('href') + '#nearby';
        $(this).attr('href', href);
    });


  	$('header.navigation-wrapper .region-secondary-navigation .views-exposed-form form > .form--inline .form-actions').on('click', function(event){
        let $this = $(this);

        if (! $this.parent().hasClass('open')) {
            $this.parent().find('.form-item-s input').val('');
        }

        if ($this.parent().find('.form-item-s input').val()) {
            $('header.navigation-wrapper .region-secondary-navigation .views-exposed-form form').submit();

            return;
        }

        $this.parent().toggleClass('open');

        if ($this.parent().hasClass('open')) {
            $this.parent().find('.form-item-s input').get(0).focus();
        }
    });
});

(function ($, Drupal) {
    Drupal.behaviors.blazyViews = {
        attach: function (context, settings) {
            window.blazy();
        }
    }


    /**
     * Generic behavior.
     *
     * @type {Drupal~behavior}
     * @type {Object} drupalSettings.geolocation
     *
     * @prop {Drupal~behaviorAttach} attach
     *   Attaches functionality to relevant elements.
     */
    Drupal.behaviors.ef2LocationInputClientLocation = {

        /**
         * @param {Object} drupalSettings.geolocation.locationInput
         * @param {LocationInputClientLocationSettings[]} drupalSettings.geolocation.locationInput.clientLocation
         */
        attach: function (context, drupalSettings) {
            console.log('clientLocation 0');

            if(!_.isNil(drupalSettings.geolocation)) {
                console.log('geolocation');

                jQuery.each(drupalSettings.geolocation.locationInput.clientLocation, function (index, settings) {
                    var input = jQuery('.location-input-client-location.' + settings.identifier, context).first();
                    //.once('location-input-client-location-processed')

                    console.log('clientLocation');

                    if (
                        navigator.geolocation
                        && input.length
                    ) {

                        console.log('clientLocation + input.length');

                        if (settings.hideForm) {
                            input.hide();
                        }
                        var successCallback = function (position) {
                            var latitudeInput = input.find('input.geolocation-input-latitude').first();
                            var longitudeInput = input.find('input.geolocation-input-longitude').first();
                            if (
                                latitudeInput.val() === ''
                                && longitudeInput.val() === ''
                            ) {
                                latitudeInput.val(position.coords.latitude);
                                longitudeInput.val(position.coords.longitude);
                                if (settings.autoSubmit) {
                                    input.closest('form').find('.js-form-submit').first().click();
                                }
                            }
                            return false;
                        };
                        navigator.geolocation.getCurrentPosition(successCallback);
                    }
                });
            }
        }
    };


})(jQuery, Drupal);


let scrollDownArrow = document.querySelector('.scroll-down-arrow');

if(!_.isEmpty(scrollDownArrow)) {
    scrollDownArrow.addEventListener('click', function () {
        window.scrollTo({
            top: window.innerHeight - 200,
            behavior: 'smooth'
        });
    });
}

let c2aButtons = document.querySelectorAll('.field--name-field-call-2-actions > .field__item');

if (!_.isEmpty(c2aButtons)) {
    Array.from(c2aButtons).forEach(function(button) {
        let field_link = button.querySelector('.field--name-field-link');
        if(_.isNil(field_link)) {
            return false;
        }
        let anchor = button.querySelector('.field--name-field-link').getElementsByTagName('a')[0].getAttribute('href');

        button.onclick = function () {
            window.location = anchor;
        }
    });
}

let photoBlocks = document.querySelectorAll(
  '.field--name-field-photoblocks > .field__item .node--type-photo-block.layout-teaser, ' +
  '.view-photo-blocks .view-content .views-row .node--type-photo-block.layout-teaser, ' +
    '.view-advertentie .layout-teaser .teaser-content-click');

if (!_.isEmpty(photoBlocks)) {
    Array.from(photoBlocks).forEach(function(block) {
       let link = block.querySelector('.field--name-field-cta').getElementsByTagName('a')[0];
       let anchor = link.getAttribute('href');

       block.onclick = function (e) {
           e.preventDefault();
         if(e.target.classList.contains('trigger')) {
           return false;
         }

           if(link.hostname !== location.hostname) {
               window.open(anchor);
           } else {
               window.location = anchor;
           }
       }
    });
}

let advancedSearchBlock = document.querySelectorAll('.adv-search-result');

if (!_.isEmpty(advancedSearchBlock)) {
    Array.from(advancedSearchBlock).forEach(function(block) {
        let anchor = block.querySelector('.cta-link')[0].getAttribute('href');

        block.onclick = function (e) {
            if(e.target.classList.contains('trigger')) {
                return false;
            }

            window.location = anchor;
        }
    });
}

let teaserSlides = document.querySelectorAll('.vue-teaser-slider .hooper-slide .layout-teaser, .vue-teaser-slider .hooper-slide .layout-teaser-articles');

if (!_.isEmpty(teaserSlides)) {
    Array.from(teaserSlides).forEach(function(slide) {
        let anchor = slide.getElementsByTagName('a');
        let hasAnchor = ! _.isEmpty(anchor);

        if (! hasAnchor) {
            slide.classList.add('no-link');
            return;
        }

        if (hasAnchor) {
            anchor  = anchor[0].getAttribute('href');
        }

        slide.onclick = function (event) {
            if (event.target.type === 'button') {
                return false
            }

            window.location = anchor;
        }
    })
}

(function ($, Drupal) {
    checkNewsOverviewTeasers();
    checkAdvertBlocks();
    checkLocationTeasers();
    checkEventsTeasers();

    Drupal.behaviors.viewTeasers = {
        attach: function (context, settings) {
            if (context.classList && context.classList.contains('view-latest-news')) {
                checkNewsOverviewTeasers();
            }

            if (context.classList && context.classList.contains('view-advertentie')) {
                checkAdvertBlocks();
            }

            if (context.classList && context.classList.contains('view-locaties')) {
                checkLocationTeasers();
            }

            if (context.classList && (context.classList.contains('view-events') || context.classList.contains('view-evenementen-overzicht'))) {
                checkEventsTeasers();
            }
        }
    };

    function checkNewsOverviewTeasers() {
        let newsOverviewTeasers = document.querySelectorAll('.view-latest-news .view-content .layout-default-teaser-news-overview');

        if (_.isEmpty(newsOverviewTeasers)) {
            return;
        }

        Array.from(newsOverviewTeasers).forEach(function(teaser) {
            let anchor = teaser.querySelector('.field--name-node-link').getElementsByTagName('a')[0].getAttribute('href');
            makeTeasersClickable(teaser, anchor);
        });
    }

    function checkAdvertBlocks() {
        let advertBlocks = document.querySelectorAll('.view-advertentie .layout-teaser-locations');

        if (_.isEmpty(advertBlocks)) {
            return;
        }

        Array.from(advertBlocks).forEach(function(teaser) {
            let anchor = teaser.querySelector('.field--type-link').getElementsByTagName('a')[0].getAttribute('href');
            makeTeasersClickable(teaser, anchor)
        })
    }

    function checkLocationTeasers() {
        let locationTeasers = document.querySelectorAll('.view-locaties .view-content .views-form form > .views-row, .view-locaties > .view-content > .views-row');

        if (_.isEmpty(locationTeasers)) {
            return;
        }

        Array.from(locationTeasers).forEach(function(teaser) {

            if (_.isEmpty(teaser.querySelector('.title-wrapper'))) {
                return;
            }

            let anchor = teaser.querySelector('.title-wrapper').getElementsByTagName('a')[0].getAttribute('href');

            makeTeasersClickable(teaser, anchor)
        });
    }

    function checkEventsTeasers() {
        let eventTeasers = document.querySelectorAll('.view-events:not(.view-display-id-block_4) .view-content .views-row, .view-evenementen-overzicht:not(.view-events-v2) .view-content .views-row');

        if (_.isEmpty(eventTeasers)) {
            return
        }

        Array.from(eventTeasers).forEach(function(teaser) {
            let title = teaser.querySelector('.field--name-node-title');

            if (_.isNil(title)) {
                title = teaser.querySelector('.views-field-title .title');
            }

            let anchor = title.getElementsByTagName('a')[0]?.getAttribute('href');

            if (_.isNil(anchor)) {
                return;
            }

            makeTeasersClickable(teaser, anchor)
        });
    }

    function makeTeasersClickable(teaser, anchor) {
        teaser.onclick = function () {
            window.location = anchor;
        }
    }
})(jQuery, Drupal);
